module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-info-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', [_vm._v("\n             Номер государственной регистрации:\n             "), _c('b', [_c('a', {
    attrs: {
      "href": _vm.getHref(),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.item.registrationNumber))])])]), _vm._v(" "), _c('v-flex', [_vm._v("\n             с "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.item.registrationDate, _vm.formats.formatDate)))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.expirationDate),
      expression: "item.expirationDate"
    }]
  }, [_vm._v(" по "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.item.expirationDate, _vm.formats.formatDate)))])]), _vm._v(" "), _c('b', [(_vm.item.actual) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formats.formatSuccessHtml('- актуальный'))
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.item.actual) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formats.formatErrorHtml('- не актуальный'))
    }
  }) : _vm._e()])]), _vm._v(" "), _c('v-flex', [_vm._v("\n              Описание: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.item.description)))])]), _vm._v(" "), _c('v-flex', [_vm._v("\n              Изображение (воспроизведение) товарного знака, знака обслуживания:\n              "), _c('div', [(!_vm.getImageUrl(_vm.item)) ? _c('span', [_vm._v("Изображение не обнаружено ")]) : _vm._e(), _vm._v(" "), (_vm.getAudioUrl(_vm.item)) ? _c('span', [_c('audio', {
    attrs: {
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.getAudioUrl(_vm.item),
      "type": "audio/mpeg"
    }
  }), _vm._v("\n                    Your browser does not support the audio element.\n                  ")])]) : _vm._e(), _vm._v(" "), (_vm.getImageUrl(_vm.item) && !_vm.item.sound) ? _c('a', {
    attrs: {
      "href": _vm.getStreamUrl(_vm.item),
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "width": "60%",
      "src": _vm.getImageUrl(_vm.item)
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('v-flex', [_vm._v("\n              Классы МКТУ и перечень товаров и/или услуг:\n              "), _c('div', [_c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.item.nice)))])])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4227e4cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/info/TrademarkForm.vue
// module id = 1067
// module chunks = 1